export const Nodata = "/images/no-data.svg";
export const NodataImg = "/images/notfound1.svg";
export const CoverImageDefault = "/images/img-cover-default.svg";
export const VideoImageDefault = "/images/image-default-video.png";
